import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { useMutation, useQuery } from '@apollo/client';
import _ from 'lodash';

import { config } from '../../../config';
import { CREATE_SCREENER_SESSION, GET_PROJECT_BY_ID } from './graphql';
import {
  Dropdown,
  DropdownSpan,
  ErrorMessage,
} from './styles';

const ApprovalActionDropdown = (props) => {
  const {
    projectId,
    tester: {
      id: testerId,
      user: {
        id: userId,
      },
    },
  } = props;

  const {
    data = {},
  } = useQuery(GET_PROJECT_BY_ID, {
    variables: {
      projectId,
    },
    fetchPolicy: 'network-only',
  });

  const { project: { segments = [] } = {} } = data;
  const filteredSurvey = segments.flatMap(
    (val) => val.surveys.filter((survey) => survey.surveyType === 'screener'),
  );

  const [createScreenerSession] = useMutation(CREATE_SCREENER_SESSION);
  const [error, setError] = useState(false);

  const dropdownOptions = useMemo(() => {
    const options = [
      { key: 1, text: 'Demographics', value: 'personal' },
      { key: 2, text: 'Employment', value: 'employment' },
    ];
    if (!_.isEmpty(filteredSurvey)) {
      options.push({ key: 3, text: 'Screeners', value: 'screeners' });
    }
    return options;
  }, [filteredSurvey]);

  const DropdownText = (
    <DropdownSpan>
      Actions
    </DropdownSpan>
  );

  const handleChange = async (e, { value }) => {
    if (value[0] === 'screeners') {
      createScreenerSession({ variables: { testerId } })
        .then((res) => {
          const { authenticationToken, id } = res.data.createScreenerSession.screenerSession;
          window.open(
            `${config.REACT_APP_TESTER_PLATFORM_URI}/screener-session?session-id=${id}&token=${authenticationToken}&requestedFrom=admin`,
          );
        }).catch(() => {
          setError(true);
        });
    } else {
      window.open(`${config.REACT_APP_ADMIN_PLATFORM_URI}/testers/${userId}/${value}`, '_blank');
    }
  };

  return (
    <>
      <Dropdown
        multiple
        item
        onChange={handleChange}
        trigger={DropdownText}
        options={dropdownOptions}
        value={null}
      />
      {error && (
        <ErrorMessage>
          Something went wrong
        </ErrorMessage>
      )}
    </>
  );
};

ApprovalActionDropdown.propTypes = {
  projectId: PropTypes.string.isRequired,
  tester: PropTypes.shape({
    id: PropTypes.string,
    user: PropTypes.shape({
      id: PropTypes.string,
    }),
  }).isRequired,
};

export default ApprovalActionDropdown;
